'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _level = require('../actions/level');

var _level_form = require('../components/level_form');

var _level_form2 = _interopRequireDefault(_level_form);

var _level_list = require('../components/level_list');

var _level_list2 = _interopRequireDefault(_level_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Level = _react2.default.createClass({
    displayName: 'Level',

    propTypes: {
        levels: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired
    },
    componentDidMount: function componentDidMount() {
        var _props = this.props,
            dispatch = _props.dispatch,
            filter = _props.filter;

        dispatch((0, _level.fetchLevelsIfNeeded)(filter));
    },
    render: function render() {
        return _react2.default.createElement(
            'div',
            { id: 'levels', className: 'clearfix' },
            _react2.default.createElement(_level_form2.default, { style: { marginBottom: 20 } }),
            _react2.default.createElement(_level_list2.default, { levels: this.props.levels })
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var levels = store.level.levels;

    return {
        levels: levels
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Level);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/levels.js
// module id = 1333
// module chunks = 0